import * as React from "react";
import { GUTTER_WIDTH } from "./cycleChartStyles";

/** Tracks an element's rendered size (callback ref + ResizeObserver). */
export const useElementSize = <T extends HTMLElement>() => {
  const [node, setNode] = React.useState<T | null>(null);
  const [size, setSize] = React.useState({ width: 0, height: 0 });

  React.useLayoutEffect(() => {
    if (!node) return;
    const measure = () => {
      const rect = node.getBoundingClientRect();
      setSize((prev) =>
        prev.width === rect.width && prev.height === rect.height
          ? prev
          : { width: rect.width, height: rect.height }
      );
    };
    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [setNode, size] as const;
};

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));

/**
 * Columns widen to fill the space on short cycles / big screens and scroll on long ones. The
 * minimum keeps each day a comfortable touch target (~28px) on a phone.
 */
export const fitColumnWidth = (availableWidth: number, columns: number, fullscreen: boolean) => {
  const [min, max] = fullscreen ? [28, 64] : [28, 44];
  if (!availableWidth || !columns) return min;
  return clamp(Math.floor((availableWidth - GUTTER_WIDTH - 2) / columns), min, max);
};
